// © Microsoft Corporation. All rights reserved.

import { SocialService } from "@msnews/social-data-service";
import { fetchSignalR } from "./fetchScripts";

export interface SignalRMessage {
    type: string;
    data: any;
}

export class WebSockets {
    private static signalRConnection: any;
    private static signalRHub: string;

    public static async open(hubName: string, onNewMessage: (message: SignalRMessage) => void, fetching = false) {
        if (WebSockets.signalRHub === hubName) {
            return;
        }

        if (window.signalR) {
            WebSockets.signalRHub = hubName;
            const info = await SocialService.getSignalRConnectionInfo(hubName);
            info.accessToken = info.accessToken || info.accessKey;
            info.url = info.url || info.endpoint;

            const options = {
                accessTokenFactory: () => info.accessToken
            };

            const connection = new window.signalR.HubConnectionBuilder()
                .withUrl(info.url, options)
                .configureLogging(window.signalR.LogLevel.Information)
                .build();

            connection.on("newMessage", onNewMessage);

            if (WebSockets.signalRConnection) {
                WebSockets.signalRConnection.stop();
            }
            WebSockets.signalRConnection = connection;
            WebSockets.signalRConnection.start()
                .catch();

            return this.get();
        } else if (!fetching) {
            // set fetching=true to make sure we don't enter infinite recursion if script fails to load
            fetchSignalR(WebSockets.open.bind(this, hubName, onNewMessage, true));
        }
    }
    public static close() {
        if (WebSockets.signalRConnection) {
            WebSockets.signalRConnection.stop();
            WebSockets.signalRConnection = undefined;
            WebSockets.signalRHub = undefined;
        }
    }

    public static get() {
        return { connection: WebSockets.signalRConnection, hub: WebSockets.signalRHub };
    }
}